module.exports = __webpack_public_path__ + "img/swiper.770ce98b.png";